import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { Pagination, StatusCode } from '../constants';
import { Observable } from 'rxjs';
import { ResponseResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})

export class RightGroupService {
  constructor(private commonService: CommonService) { }

  getAll(pageSize: number = Pagination.PageSize, pageIndex: number = Pagination.PageIndex): Observable<ResponseResult> {
    return this.commonService.getAll(`right-group`, false, pageSize, pageIndex);
  }

  getByRightGroupId(id:number, pageSize: number = Pagination.PageSize, pageIndex: number = Pagination.PageIndex): Observable<ResponseResult> {
    return this.commonService.getAll(`right-group/modules/${id}`, false, pageSize, pageIndex);
  }

  create(model): Observable<ResponseResult> {
    return this.commonService.createData(`right-group`, model);
  }

  update(model): Observable<ResponseResult> {
    return this.commonService.updateData(`right-group/${model.rightGroupId}`, model);
  }

  delete(id): Observable<ResponseResult> {
    return this.commonService.deleteData(`right-group/${id}`);
  }
}
